<template>
    <mode-switcher
        ref="modeSwitcher"
        :main-mode-text="$t('create')"
        :create-mode-text="$t('discount_creating')"
        :edit-mode-text="$t('discount_editing')"
        @reset="discountEditModalSelected = null"
    >
        <template v-slot:btn-block>
            <div class="full-width d-flex align-center">
                <v-spacer />
                <FilterStatusToggle v-model="activeFilter" />
            </div>
        </template>
        <template v-slot:main-mode>
            <v-data-table
                :items="discountsFiltered"
                :headers="headers"
                :loading="isDiscountsLoading"
                class="elevation-1 table-server"
                :custom-key-sort="{
                    name: (a, b) => localized(a).localeCompare(localized(b)),
                }"
                :sort-by="[{key: 'name', order: 'asc'}]"
                must-sort
            >
                <template v-slot:item.name="{item}">
                    <span class="text-link font-weight-medium text-decoration-underline" @click="showEditModal(item)">
                        {{ localized(item.name) }}
                    </span>
                </template>
                <template v-slot:item.discountConditions="{item}">
                    <span style="white-space: pre-line">
                        {{ getConditionLabel(item.discountConditions) }}
                    </span>
                </template>
                <template v-slot:item.active="{item}">
                    <span>
                        {{ item.active ? $t('active') : $t('inactive') }}
                    </span>
                </template>
            </v-data-table>
        </template>
        <template v-slot:additional-mode>
            <DiscountForm
                :discount="discountEditModalSelected"
                :contract="contract"
                :selected-locale="selectedLocale"
                @on-close="onCloseEditModal"
                @on-save="onDiscountSave"
            />
        </template>
    </mode-switcher>
</template>

<script lang="ts">
    import {Component, Emit, Prop, Setup, Vue} from 'vue-facing-decorator'

    @Component({
        components: {},
    })
    export class ProductPricesDiscounts extends Vue {
        @Prop() contract
        @Prop() selectedLocale
        @Prop() discounts
        @Prop() isDiscountsLoading
        @Setup(() => useLocalized()) localized: Function

        discountEditModalSelected = null
        activeFilter = true

        @Emit()
        async onDiscountSave() {}

        showEditModal(discount) {
            this.discountEditModalSelected = discount
            this.$refs.modeSwitcher.edit()
        }

        onCloseEditModal() {
            this.$refs.modeSwitcher.goToTable()
        }

        getConditionLabel(condition) {
            return `${condition.unitOfMeasurement === 'PERCENT' ? condition.discountValue : condition.discountValue.toFixed(2)} ${
                condition.unitOfMeasurement === 'PERCENT'
                    ? '% ' + this.$t('penalty_cancel_description.from_the')
                    : this.contract?.transactionsCurrency
            }
            ${
                condition.countOfTourists
                    ? this.$t('discount_terms.for_groups_from') +
                      ' ' +
                      condition.countOfTourists +
                      ' ' +
                      this.$t('discount_terms.passengers')
                    : this.$t('discount_terms.for_all_tourists')
            }
            `
        }

        get headers() {
            return [
                {title: this.$t('name'), value: 'name', sortable: true},
                {title: this.$t('conditions'), value: 'discountConditions'},
                {title: this.$t('status'), value: 'active'},
            ]
        }

        get discountsFiltered() {
            return this.discounts.filter(el => this.activeFilter === el.active)
        }
    }

    export default ProductPricesDiscounts
</script>
